export const ANONYMOUS_APPEAL_STORAGE_KEY = "anonymousAppealId";
export const LAST_ACTIVITY_AT_STORAGE_KEY = "lastActivityAt";
